/**
 * Created by Gaplo917 on 16/8/2017.
 */
import * as SoundUtils from './SoundUtils'
import * as Rx from 'rxjs'

export default class SoundManager {
  constructor(){
    this.backgroundSound = null
    this.effectSounds = {}
  }

  playBackground(opt){
    const sound = SoundUtils.create(opt)
    sound.play()

    this.backgroundSound = sound
  }

  playEffect(opt, onComplete){
    const sound = SoundUtils.create(opt)

    sound.play(onComplete)

    // use the combined src as a ID
    const id = this.generateId(opt)

    // save it
    this.effectSounds[id] = sound

    return sound
  }

  playEffectRx(opt){
    return Rx.Observable.create(obs => {
        this.playEffect(opt, () => {
          obs.next()
          obs.complete()
        })
    })
  }

  stopEffect(opt){
    const id = this.generateId(opt)

    const sound = this.effectSounds[id]

    if(sound){
      sound.stop()
    }
  }

  generateId(opt){
    return Array.isArray(opt.src) ? opt.src[0] : opt.src
  }

  getSound(opt){
    return this.effectSounds[this.generateId(opt)] || this.backgroundSound
  }

  stopBackground(){
    if(this.backgroundSound){
      this.backgroundSound.stop()
    }
  }

  stopEffectSounds(){
    for(let k in this.effectSounds){
      this.effectSounds[k].stop()
    }
  }

  stopAll(){
    this.stopBackground()
    this.stopEffectSounds()
  }

}

SoundManager.instance = new SoundManager()



// WEBPACK FOOTER //
// ./src/game/SoundManager.js